var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative z-0 flex justify-center inline-flight-booking"},[_c('flight-booking-form',{staticClass:"p-4",attrs:{"show-close-btn":_vm.showCloseBtn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }